import { Heading, Text, Box, Center, Card, CardHeader, CardBody } from "@chakra-ui/react";
import { Helmet } from 'react-helmet';

export default function SLAfterPayment() {
  return (
    <>
      <Helmet>
        <title>Ką rengtis pagal Viliją Rušinskaitę - Apmokėjimas gautas!</title>
      </Helmet>
      <Box minH='2vw' />
      <Center>
        <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
          <CardHeader>
            <Box minH='1vw' />
            <Center>
              <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>
                Apmokėjimas gautas!
              </Heading>
            </Center>
          </CardHeader>
          <CardBody paddingTop="0px">
            <Box>
              <Text pt='2' fontSize='lg' textAlign='center'>
                Netrukus gausite nuorodą į shopping list'ą elektroniniu laišku.
              </Text>
            </Box>
          </CardBody>
        </Card>
      </Center>
    </>
  );
}
